<template>
  <div class="bt-transaksi pb-5">
    <div class="pa-3 mb-5">
      <div class="d-flex align-center">
        <v-row class="mt-1">
          <v-col cols="12">
            <v-card
              class="pt-5 pb-1 px-2 rounded-lg mt-3"
              :style="{
                backgroundColor: $vuetify.theme.dark ? 'var(--dark-bg)' : 'var(--light-bg)',
              }"
            >
              <h4 class="text-subtitle-2 font-weight-bold rounded-lg px-3">Registrasi Anggota</h4>
              <v-divider class="ma-3" style="border-color: #ff9b6a"></v-divider>
              <v-row>
                <v-col cols="6" class="px-1">
                  <div class="text-center">
                    <router-link to="/keanggotaan/registrasiMasuk" style="text-decoration: none; color: inherit">
                      <img src="@/assets/icon/anggota_in.png" alt="" contain height="50" class="mx-auto" />
                      <p class="text-caption font-weight-bold mt-2">Anggota Masuk</p>
                    </router-link>
                  </div>
                </v-col>
                <v-col cols="6" class="px-1">
                  <div class="text-center">
                    <router-link to="/keanggotaan/registrasiKeluar" style="text-decoration: none; color: inherit">
                      <img src="@/assets/icon/anggota_out.png" alt="" contain height="50" class="mx-auto" />
                      <p class="text-caption font-weight-bold mt-2">Anggota Keluar</p>
                    </router-link>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Keangotaan",
};
</script>
